import { render, staticRenderFns } from "./groupAuthorize.vue?vue&type=template&id=6bbd53e8&scoped=true&"
import script from "./groupAuthorize.vue?vue&type=script&lang=js&"
export * from "./groupAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./groupAuthorize.vue?vue&type=style&index=0&id=6bbd53e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd53e8",
  null
  
)

export default component.exports